import { Component, Input, Output, EventEmitter, OnInit, inject } from "@angular/core";
import { MoiModel } from "@models/moi/MoiModel";
import { MoiDataService } from "@app/moi/services/moi-data.service";
import { RiskLinkModel } from "@models/risk/RiskLinkModel";
import { SearchKeyword } from "@models/workspace/SearchKeyword";
import { nameof } from "@methods/jeffs-toolkit";
import { ComparisonType } from "@enums/workspace/ComparisonType";
import { ModuleType } from "@enums/ModuleType";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { RiskLinkableComponent } from "@app/risk/pages/risk-linkable/risk-linkable.component";

@Component({
    selector: "moi-risks",
    templateUrl: "./moi-risks.component.html",
    styleUrls: ["./moi-risks.component.scss"],
    imports: [TranslatePipe, RiskLinkableComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiRisksComponent implements OnInit {
    private moiDs = inject(MoiDataService);

    @Input() model: MoiModel;
    @Input() disabled = false;

    moduleType = ModuleType.BIM;
    activeFilters: SearchKeyword[] = [];

    @Output() changed = new EventEmitter<number[]>();

    isLoading = true;
    lastOrganizationId = 0;
    linked: RiskLinkModel[];
    unlinked: RiskLinkModel[];

    ngOnInit(): void {
        const defaultOrganizationFilter = <SearchKeyword>{
            col: nameof<RiskLinkModel>((x) => x.organizationId),
            searchValue: this.model.OrganizationResponsible + "",
            specific: true,
            compareType: ComparisonType["Is equal to"],
        };

        this.activeFilters.push(defaultOrganizationFilter);
    }

    load() {
        if (
            !this.model ||
            !this.model.OrganizationResponsible ||
            this.lastOrganizationId === this.model.OrganizationResponsible
        ) {
            return;
        }

        this.isLoading = true;
        this.lastOrganizationId = this.model.OrganizationResponsible;

        this.moiDs.getLinkableRisks(this.model.Guid).subscribe((value) => {
            this.loadData(this.model.LinkedRisks, value.sortBy("name", true));
            this.isLoading = false;
        });
    }

    linkedChanged(linked: RiskLinkModel[]) {
        this.model.LinkedRisks = linked.map((x) => x.id);
        this.changed.emit(this.model.LinkedControls);
    }

    private loadData(linkedIds: number[], items: RiskLinkModel[]) {
        const linked = [],
            unlinked = [];
        for (const item of items) {
            if (linkedIds.indexOf(item.id) >= 0) {
                linked.push(item);
            } else {
                unlinked.push(item);
            }
        }

        this.linked = linked;
        this.unlinked = unlinked;
    }
}
